import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../../app';

interface MenuItemI {
  isFavoriteMenuOpen: boolean;
}

const initialState: MenuItemI = {
  isFavoriteMenuOpen: true,
};

const stateSlice = createSlice({
  name: 'menu/state',
  initialState,
  reducers: {
    setFavoriteMenuOpen: (state, action) => {
      state.isFavoriteMenuOpen = action.payload;
    },
  },
});

export const { setFavoriteMenuOpen } = stateSlice.actions;

export const menuState = (state: RootState) => state.menu.state;

export default stateSlice.reducer;
